export function getCategorySchemas(slug: string, categoryName: string) {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: `${categoryName} - 2pg·com 游戏分类`,
      url: `https://2pg.com/category/${slug}`,
      description: `2pg·com ${categoryName}，海量游戏资源，快速开户注册，安全加密保障，随时随地畅享优质游戏体验。`,
      isPartOf: {
        '@type': 'WebSite',
        name: '2pg·com',
        url: 'https://2pg.com',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://2pg.com',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: categoryName,
          item: `https://2pg.com/category/${slug}`,
        },
      ],
    },
  ];
}